/**
 * @file sprint.tsx
 * @description Компонент страницы отчётов по спринтам для генерации комплексных отчётов по спринтам для 
 * управления проектами и анализа. Предоставляет детальную функциональность отчётности по спринтам с анализом 
 * задач, отслеживанием статуса, визуализацией временных рамок и возможностями фильтрации. Включает кликабельные 
 * строки для детального анализа с детализацией и поддерживает фильтрацию по номеру задачи, ответственному лицу, 
 * диапазонам дат и статусу спринта для комплексной отчётности по проектам и получения инсайтов для управления.
 * @author AI Assistant
 * @created 2025-09-04
 * @updated 2025-09-04
 * @dependencies ['@utils/table-view', '@features/filter', '@features/filter/types']
 * @related-files ['@features/filter-modal/forms/ReportSprint.tsx']
 */

import { getDefaultCell, getDateTimeCell } from '@utils/table-view';
import { ReportSprint } from '@features/filter';
import { filterComponent } from '@features/filter/types';
import { TBaseObjectDto } from '../../types';

export const title = 'Отчёт по спринтам';
export const searchModalTitle = 'Отчёт по спринтам';
export const type = 'Sprint';
export const path = 'report-sprint';
export const isRowClickable = true;
export const filterModalForm = ReportSprint;

export const columns = [
    {
        id: '$item',
        header: [{ text: 'Номер' }],
        width: 320,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'name',
        header: [{ text: 'Описание' }],
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'state',
        header: [{ text: 'Статус' }],
        width: 130,
        render: (cellValue: any) => getDefaultCell(cellValue)
    },
    {
        id: 'dateStart',
        header: [{ text: 'Начало' }],
        width: 100,
        render: (cellValue: number) => getDateTimeCell(cellValue, 'dd DD.MM.YY')
    },
    {
        id: 'dateEnd',
        header: [{ text: 'Окончание' }],
        width: 100,
        render: (cellValue: number) => getDateTimeCell(cellValue, 'dd DD.MM.YY')
    }
];

export const getFilterControls = (data: TBaseObjectDto = {}): filterComponent[] => [
    {
        filterType: 'dictionary',
        filterProps: {
            label: 'Номер'
        },
        name: 'task',
        type: 'Task',
        value: data.task,
        tab: 'filters'
    },
    {
        filterType: 'dictionary',
        filterProps: {
            label: 'Ответственный',
            type: 'User'
        },
        value: data.executor,
        name: 'executor',
        tab: 'filters'
    },
    {
        filterType: 'dateRange',
        filterProps: {
            label: 'Дата'
        },
        value: data.date,
        name: 'date',
        tab: 'filters'
    },
    {
        filterType: 'select',
        filterProps: {
            label: 'Статус',
            emptyItem: 'Все'
        },
        type: 'ESprintState',
        value: data.state,
        name: 'state',
        tab: 'filters'
    }
];
